import React, { useState, useEffect } from 'react';

import './WinEditStep3.css';

const WinEditStep3 = (props) => {
    const [ comment, setComment ] = useState(props.data.comment);

    /**
     * append switch yes in comment
     * @description window comment should follow the pattern as '<userName> | <BCP: switch yes; ECP: switch yes> | window comment here'
     * @assumption window comment itself should not contain '|', which used as the delimiter of the above three parts
     */
    useEffect(() => {
        if (props.data.switchYes) {
            const arrCommentParts = props.data.comment.split(' | ');
            const bcpName = props.data.switchYes.beginMilepost?.controlPointName || '',
                ecpName = props.data.switchYes.endMilepost?.controlPointName || '';

            let switchYesSettings = '';
            if (props.data.switchYes.beginMilepost?.switchYes) {
                switchYesSettings += `${bcpName}: Switch Yes`;
            }
    
            if (props.data.switchYes.endMilepost?.switchYes && bcpName !== ecpName) {
                if (switchYesSettings) {
                    switchYesSettings += '; ';
                }
    
                switchYesSettings += `${ecpName}: Switch Yes`;
            }
            
            let newComment = '';

            // window comment only
            if (arrCommentParts.length === 1) {
                newComment = [ switchYesSettings, props.data.comment ].join(' | ');
            }
            // two scenarios: <userName> | <window comment> OR <switchYes> | <window comment> 
            else if (arrCommentParts.length === 2) { 
                // <switchYes> | <window comment>
                if (arrCommentParts[0].includes('Switch Yes')) {
                    newComment = [ switchYesSettings, arrCommentParts[1] ].join(' | ');
                }
                // <userName> | <window comment>
                else {
                    newComment = [ arrCommentParts[0], switchYesSettings, arrCommentParts[1] ].join(' | ');
                }                
            } else {    // <userName> | <switchYes> | <window comment>
                newComment = [ arrCommentParts[0], switchYesSettings, arrCommentParts[2] ].join(' | ');
            }

            setComment(newComment);
            props.updateWin({ comment: newComment });
        }
    }, []);

    const onCancel = () => props.onCancel();
    const goBack = () => props.onBack();

    const onChange_comment = (evt) => {
        const newValue = evt.target.value;
        setComment(newValue);

        props.updateWin({ comment: newValue });
    }

    const onSubmit = () => {
        props.onSubmit && props.onSubmit();
    };

    return (
        <div className='clsWinEditStep clsWinEditStep3'>
            <div className='clsWinEditStep-block'>
                <div className='clsWinEditStep-ctrl-label'>Comments</div>
                <textarea className="form-control" rows="5" value={ comment } onChange={ onChange_comment }></textarea>
            </div>
            <div className='clsWinEditStep-block'>
                <button className='btn btn-bwwp-secondary' onClick={ onCancel }>CANCEL</button>
                <button className='btn btn-raised btn-bwwp-primary' onClick={ onSubmit } disabled={ props.submitStatus === 'ON_SUBMIT_START' }>Submit</button>
                <button className='btn btn-raised btn-bwwp-secondary' onClick={ goBack }>Back</button>
            </div>
        </div>
    );
};

export default WinEditStep3;